<template>
  <div v-if="_.isEmpty(modelProps)" class="text-center">Không có dữ liệu</div>
  <div v-else>
    <div class="row" :style="'margin: 0 ' + margin + 'px'">
        <q-inner-loading :showing="load">
          <q-spinner-ball size="50px" color="green"/>
        </q-inner-loading>
        <apexchart :key="chartKey" ref="apexChart" :width="chartConfig.width" :height="chartConfig.height" :options="_.cloneDeep(chartConfig)" :series="computedSeries"/>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Array, Object]
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      load: null,
      margin: this.$q.screen.xs ? 0 : -20,
      chartConfig: {
        chart: {
          toolbar: {
            show: this.$q.screen.xs
          },
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false
            },
            dynamicAnimation: {
              enabled: false
            }
          }
        },
        height: 400,
        width: this.$q.screen.width - (this.$q.screen.width * 0.03),
        legend: {
          position: 'top',
          fontSize: 16
        },
        dataLabels: {
          fontSize: 14
        },
        colors: ['#00a152', '#f44336', '#2196f3', '#9c27b0', '#00bcd4 ', '#ffeb3b', '#795548'],
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            showDuplicates: false
          },
          tickAmount: 1
        }
      },
      isPlus: true,
      chartKey: 0,
      series: this.initSeries(),
      computedSeries: []
    }
  },
  created () {
    this.load = true
    if (this._.isEmpty(this.modelProps)) {
      this.$emit('command', { cmd: 'empty-data', config: this.config })
    }
    this._.merge(this.chartConfig, this.config.chartOptions)
    this.computedSeries = this.calculateSeriesData()
  },
  watch: {
    modelProps: {
      handler: function () {
        this.computedSeries = this.calculateSeriesData()
      },
      deep: true
    }
  },
  methods: {
    initSeries () {
      let vm = this
      let series = []
      for (let i in vm.config.value) {
        series.push({
          key: vm.config.value[i],
          name: vm.config.headers[i],
          type: vm.config.chartType
        })
      }
      return series
    },
    calculateSeriesData () {
      let vm = this
      if (!vm.modelProps) return []
      let modelPropsClone = vm._.cloneDeep(vm.modelProps)
      let chart = []
      chart.push(vm.config.headers)
      if (typeof vm.modelProps === 'object') {
        let newModel = []
        for (let key in modelPropsClone) {
          newModel = newModel.concat(modelPropsClone[key])
        }
        modelPropsClone = newModel
      }
      modelPropsClone.sort((a, b) => a[vm.config.key].toDate().getTime() > b[vm.config.key].toDate().getTime() ? 1 : a[vm.config.key].toDate().getTime() === b[vm.config.key].toDate().getTime() ? 0 : -1)
      let computedSeries = vm._.cloneDeep(vm.series)
      for (let i in vm.config.value) {
        computedSeries[i].data = []
        modelPropsClone.forEach(element => {
          computedSeries[i].data.push({
            x: element[vm.config.key].toDate().getTime(),
            y: isNaN(element[vm.config.value[i]]) ? null : element[vm.config.value[i]]
          })
        })
      }
      if (this.$refs.apexChart) {
        this.$refs.apexChart.refresh()
      }
      vm.load = false
      return computedSeries
    }
  },
  components: {
    'apexchart': VueApexCharts
  }
}
</script>
